import { ArticleHero, ShareButton } from '@okam/brand-ui/index'
import { truncate } from 'lodash'
import { useTranslation } from 'next-i18next'
import { theme } from 'twin.macro'
import { MainLayout } from 'components/layout'
import Seo from 'components/Seo'
import type { SeoContentFragment } from 'gql/graphql'
import { trackContentSharing } from 'gtm-analytics/tracking'
import { Html2React } from 'lib/html2react'
import useArticle from 'lib/react-query/useArticle'
import type { TDirectusProps } from '../../../components/layout/MainLayout'

export interface TArticlePage {
  slug: string
  locale: string
  seo: { seo: SeoContentFragment | null | undefined; pageTitle: string }
  directusProps: TDirectusProps
}

const ArticlePage = ({ slug, locale, seo, directusProps }: TArticlePage) => {
  const { data, isSuccess } = useArticle(slug, locale)
  const content = data?.translations?.[0]?.content

  const featuredImage = data?.translations?.[0]?.featuredImage
    ? data?.translations?.[0]?.featuredImage
    : data?.featuredImage

  const { t } = useTranslation('common')

  return (
    <>
      <Seo directusData={directusProps} seo={seo?.seo} pageTitle={seo?.pageTitle} />
      <MainLayout footerProps={directusProps}>
        {isSuccess && (
          <>
            <ArticleHero
              title={data?.translations?.[0]?.title ?? ''}
              heroImage={{
                id: featuredImage?.id ?? '',
                description: featuredImage?.description ?? '',
                filenameDownload: featuredImage?.filenameDownload ?? '',
              }}
              bgColor={theme('colors.primary[2]')}
              shareWidget={
                <ShareButton
                  onShare={(sharingMedium) => trackContentSharing(sharingMedium)}
                  text={truncate(data?.translations?.[0]?.content ?? '', { length: 150 })}
                />
              }
              parentLink={locale}
              backLinkText={t('ROUTES.GOBACK', { p: 'articles' })}
            />
            {content && <Html2React tw="my-32" content={content} />}
          </>
        )}
      </MainLayout>
    </>
  )
}

export default ArticlePage
